const contents = {
    en:{
        enter_bgd_video: require('@/files/enter/CEMOY-Gallery-EN-Enter.mp4'),
        enter_poster_img: require('@/files/enter/CEMOY-Gallery-EN-Enter.jpg'),
        enter_circle_normal: require('@/files/enter/circleNormal.png'),
        enter_circle_small: require('@/files/enter/circleSmallNew.png'),
        enter_circle_middle: require('@/files/enter/circleMiddleNew.png'),
        enter_circle_big: require('@/files/enter/circleBigNew.png'),
        enter_circle_out: require('@/files/enter/circleOutNew.png'),
        enter_background_img: require('@/files/enter/web-background.jpg'),
        enter_title_img: require('@/files/enter/title.png'),
//mobile
        enter_bgd_video_mobile: require('@/files/enter/CEMOY-Gallery-EN-MOBILE-Enter.mp4'),
        enter_poster_img_mobile: require('@/files/enter/CEMOY-Gallery-EN-MOBILE-Enter.jpg'),
        enter_circle_normal_mobile: require('@/files/enter/circleNormalMobile.png'),
        enter_background_img_mobile: require('@/files/enter/mob-background.jpg'),
//archive
        enter_bgd_img: require('@/files/enter/door.png'),
        enter_badge_img: require('@/files/enter/badge.svg').default,
        enter_shape_img: require('@/files/enter/shape.gif'),
        enter_shape_text: 'SWIPE TO DISCOVER OUR VR STORE',
        enter_title: <><h2>WELCOME TO THE</h2>
            <h1>GALLERY</h1>
            <h2>OF</h2>
            <h1>CEMÔY</h1></>,
        enter_line1: <>Free to explore the world of creativity, <br />infused into each work the notion of haute couture, art and the endless imagination. Every experience, product and design tells a unique story, a story articulated with exquisite illustrations and the finest craftsmanship.</>,
        enter_line2: <>Explore, experience and immerse yourself in the world of CEMÔY, where boundaries are pushed, skincare evolves and become innovative.</>,
        enter_btn_text: 'ENTER'
    },
    ch:{
        enter_bgd_video: require('@/files/enter/CEMOY-Gallery-CN-Enter.mp4'),
        enter_poster_img: require('@/files/enter/CEMOY-Gallery-CN-Enter.jpg'),
        enter_circle_normal: require('@/files/enter/circleNormal.png'),
        enter_circle_small: require('@/files/enter/circleSmallNew.png'),
        enter_circle_middle: require('@/files/enter/circleMiddleNew.png'),
        enter_circle_big: require('@/files/enter/circleBigNew.png'),
        enter_circle_out: require('@/files/enter/circleOutNew.png'),
        enter_background_img: require('@/files/enter/web-background.jpg'),
        enter_title_img: require('@/files/enter/title_cn.png'),
//mobile
        enter_bgd_video_mobile: require('@/files/enter/CEMOY-Gallery-CN-MOBILE-Enter.mp4'),
        enter_poster_img_mobile: require('@/files/enter/CEMOY-Gallery-CN-MOBILE-Enter.jpg'),
        enter_circle_normal_mobile: require('@/files/enter/circleNormalMobile.png'),
        enter_background_img_mobile: require('@/files/enter/mob-background.jpg'),
//archive
        enter_bgd_img: require('@/files/enter/door.png'),
        enter_badge_img: require('@/files/enter/badge.svg').default,
        enter_shape_img: require('@/files/enter/shape.gif'),
        enter_shape_text: '滑动探索VR云店',
        enter_title: <><h2>欢迎进入</h2>
            <h1>寰宇之境</h1>
            <h2>CEMÔY</h2>
            <h1>艺术藏馆</h1>            </>,
        enter_line1: <>CEMÔY将「无界」设计思维注入到每一款灵魂作品中， <br />用做高定及艺术的初心打造作品，无垠于想象。</>,
        enter_line2: <>每一次体验，皆享非凡。每一件产品，皆赋高效。 <br />每一个美的灵魂，皆书写独一无二的故事。 <br />每一款CEMÔY作品，均赋以标志性的插画元素，用非凡工艺精致雕琢。 <br />我们坚持以不灭的爱和创造力铸造这些作品，<br />汇聚成光，予你照见和陪伴。</>,
        enter_btn_text: '即刻探寻'
    }
}

export function getContent(code, key){
    return contents[code][key]
}

// import { getContent } from './content.js'
// { getContent(language, 'xxxxxxxx') }
